var React = require('react');

function SortBy (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"4","y1":"16","x2":"6","y2":"16","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"10","y1":"16","x2":"20","y2":"16","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("line",{"x1":"7","y1":"13","x2":"7","y2":"19","stroke":"currentColor","strokeWidth":"2","key":2}),React.createElement("line",{"x1":"18","y1":"8","x2":"20","y2":"8","stroke":"currentColor","strokeWidth":"2","key":3}),React.createElement("line",{"x1":"4","y1":"8","x2":"14","y2":"8","stroke":"currentColor","strokeWidth":"2","key":4}),React.createElement("line",{"x1":"17","y1":"5","x2":"17","y2":"11","stroke":"currentColor","strokeWidth":"2","key":5})]);
}

SortBy.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SortBy;

SortBy.default = SortBy;
